<template>
    <div v-if="enrollment.id">
        <card-header title="Registration" icon="fa-user"></card-header>

        <!--        <card-toolbar v-if="!enrollment.is_deleted">-->
        <!--            <button @click="$openCard('edit-registration', {confId: props.confId, regId: enrollment.id}, card)"><i class="far fa-pencil"></i>Edit</button>-->
        <!--            <button @click="$openCard('refund-registration', {confId: props.confId, regId: enrollment.id}, card)"><i class="far fa-times"></i>Refund/Delete</button>-->
        <!--        </card-toolbar>-->

        <card-body>
            <card-list>

                <!--                <container-list-item padded v-if="enrollment.is_deleted" style="background: #a60707;" class="has-text-white has-text-weight-bold"><i class="fas fa-info-circle mr-2 fa-fw ml-2"></i>This registration has been deleted.</container-list-item>-->


                <subheader-list-item title="Enrollment" icon="fa-id-card" />
            </card-list>

            <data-row title="Full Name">
                <span class="clickable" @click="$copyText(enrollment.users.first_name + ' ' + enrollment.users.last_name)">{{ enrollment.users.first_name }} {{ enrollment.users.last_name }}</span>
            </data-row>
            <data-row title="Enrolled Date">{{ enrollment.created_at | moment('MMMM Do YYYY, h:mm:ss a') }}</data-row>
            <data-row title="Started Date"><span v-if="enrollment.setup_approved_at">{{ enrollment.setup_approved_at | moment('MMMM Do YYYY, h:mm:ss a') }}</span></data-row>
            <data-row title="Completed Date">{{ enrollment.completed_at | moment('MMMM Do YYYY, h:mm:ss a') }}</data-row>

            <card-list>
                <separator-list-item/>

                <navigation-list-item
                    title="Course Responses"
                    icon="fa-comment"
                    @click="$openCard('enrollment-data', {enrollId: enrollment.id}, card)"
                    :active="(child && child.definition.component === 'enrollment-data' && enrollment.id === parseInt(child.props.enrollId))"
                />

                <subheader-list-item title="Personal" icon="fa-id-card" />
            </card-list>

            <data-row title="E-Mail Address"><span class="clickable" @click="$copyText(enrollment.users.email)">{{ enrollment.users.email }}</span></data-row>
            <data-row title="Alt E-Mail Address"><span class="clickable" @click="$copyText(enrollment.users.email_alt)">{{ enrollment.users.email_alt }}</span></data-row>
            <data-row title="Home Phone"><span class="clickable" @click="$copyText(enrollment.users.phone)">{{ enrollment.users.phone | tel }}</span></data-row>
            <data-row title="Work Phone"><span class="clickable" @click="$copyText(enrollment.users.phone_2)">{{ enrollment.users.phone_2 | tel }}</span></data-row>
            <data-row title="Address">
                <div class="clickable" @click="$copyText(enrollment.users.address + ((enrollment.users.address_2)?', '+enrollment.users.address_2:', ') + enrollment.users.city + ', ' + enrollment.users.state + ' ' + enrollment.users.zip)">
                    <div>{{ enrollment.users.address }}</div>
                    <div v-if="enrollment.users.address_2">{{ enrollment.users.address_2 }}</div>
                    <div>{{ enrollment.users.city }}, {{ enrollment.users.state }} &nbsp;{{ enrollment.users.zip }}</div>
                </div>
            </data-row>

            <!--            <card-list>-->
            <!--                <subheader-list-item title="Educator" icon="fa-chalkboard-teacher"/>-->
            <!--            </card-list>-->

            <!--            <data-row title="Grade Level">{{ enrollment.user.grade_level }}</data-row>-->
            <!--            <data-row title="Subject">{{ enrollment.user.subject_area }}</data-row>-->
            <!--            <data-row title="School">{{ enrollment.user.school }}</data-row>-->
            <!--            <data-row title="District">{{ enrollment.user.district }}</data-row>-->

            <!--            <card-list>-->
            <!--                <subheader-list-item title="Payment" icon="fa-credit-card"/>-->
            <!--            </card-list>-->

            <!--            <data-row title="On File"></data-row>-->

            <!--            <card-list>-->
            <!--                <subheader-list-item title="Registration Questions" icon="fa-question-circle"/>-->
            <!--            </card-list>-->

            <card-list>
                <subheader-list-item title="Applications" icon="fa-list-alt" />


                <!--            <applicant-tile-->
                <!--                :applicant="applicant"-->
                <!--                :card="card"-->
                <!--                v-for="applicant in enrollment.enrollment_applications"-->
                <!--                @click="$openCard('application-applicant', {applicantId: applicant.id, applicationId: props.applicationId, applicantType: applicant.type}, card)"-->
                <!--                :active="(child && child.definition.component === 'application-applicant' && applicant.id === parseInt(child.props.applicantId))"-->
                <!--            />-->

                <card-list-item @click="$openCard('application-applicant', {applicantId: applicant.id, applicationId: applicant.course_applications.applications.id, applicantType: 'course'}, card)" v-for="applicant in enrollment.enrollment_applications">
                    <template v-slot:icon><i class="far fa-fw fa-file"></i></template>
                    <template v-slot:content>
                        <div class="has-text-weight-bold">{{ applicant.course_applications.applications.title }}</div>
                        <div>
                            <div class="meta">{{ applicant.created_at | moment('MMMM Do YYYY, h:mm:ss a') }}</div>
                        </div>
                    </template>
                    <template v-slot:status>
                        <div class="stats">
                            <!--                        <span class="stat"><i class="fas fa-fw" :class="{'fa-check': applicant.completed_at, 'fa-exclamation-triangle': !applicant.completed_at}"></i></span>-->
                        </div>
                    </template>
                    <template v-slot:details>
                        <!--                    <div class="tile-details">-->
                        <!--                        <div class="data mt-1">-->
                        <!--                            <data-row mini title="Type">{{applicant.type.replace('conf', 'Conference') | capitalize}}</data-row>-->
                        <!--                            <data-row mini title="Started">{{applicant.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>-->
                        <!--                            <data-row mini title="Completed"><span v-if="applicant.completed_at">{{applicant.completed_at | moment('MMMM Do YYYY, h:mm:ss a')}}</span></data-row>-->
                        <!--                            <data-row mini title="Minutes">{{applicant.total_minutes}}</data-row>-->
                        <!--                            <data-row mini title="Units">{{applicant.total_units}}</data-row>-->
                        <!--                            <data-row mini title="Quoted Price">{{applicant.quoted_price | currency}}</data-row>-->
                        <!--                            <data-row mini title="Paid">{{applicant.total_paid | currency}}</data-row>-->

                        <!--                            &lt;!&ndash;                    <data-row mini title="Confirmation">{{ registration.code }}</data-row>&ndash;&gt;-->
                        <!--                            &lt;!&ndash;                    <data-row mini title="Payment">&ndash;&gt;-->
                        <!--                            &lt;!&ndash;                        <span v-if="registration.payment_type === 'cc'">{{registration.total_paid | currency}} by Credit Card</span>&ndash;&gt;-->
                        <!--                            &lt;!&ndash;                        <span v-if="registration.payment_type === 'po'">{{registration.total_paid | currency}} by Purchase Order</span>&ndash;&gt;-->
                        <!--                            &lt;!&ndash;                    </data-row>&ndash;&gt;-->
                        <!--                        </div>-->
                        <!--                    </div>-->
                    </template>
                </card-list-item>
            </card-list>

            <card-list>
                <subheader-list-item title="Certification/Integrations" icon="fa-list-alt" />
            </card-list>

            <data-row :title="c.certification_integrations.title" v-for="c in enrollment.users.user_certification">{{ c.certification_number }}</data-row>


        </card-body>
    </div>
</template>
<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import ConferenceTile from "../../../components/tiles/ConferenceTile";

    import {client as http} from "@/http_client";
    import moment from "moment";
    import ApplicantTile from "../../../components/tiles/ApplicantTile.vue";
    import CardListItem from "../../../TIER/components/CardListItem.vue";
    import EnrollmentTile from "../../../components/tiles/EnrollmentTile.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {EnrollmentTile, CardListItem, ApplicantTile, ConferenceTile, ContainerListItem, SeparatorListItem, DataRow, CardHeader, CardToolbar, CardBody, SearchListItem, NavigationListItem, SubheaderListItem, CardList},
        data() {
            return {
                enrollment: {}
            };
        },
        methods: {
            loadEnrollment: function (force) {
                this.$emit('loading', true);
                http.get('courses/new/enrollment/' + this.props.enrollId, {force}).then(response => {
                    this.enrollment = response.data;
                    this.$emit('loading', false);
                });
            },
            activate: function () {
                // http.post('conferences/' + this.props.confId + '/registrations/' + this.props.regId + '/activate').then(response => {
                //     this.loadEnrollment(true);
                //     this.$reloadCard('registrations', {confId: this.props.confId});
                //     this.$reloadCard('conference', {confId: this.props.confId});
                // });
            },
            reload: function () {
                this.loadEnrollment(true);
            }
        },
        computed: {},
        watch: {
            'props.enrollId': function () {
                this.loadEnrollment(true);
            }
        },
        mounted: function () {
            this.loadEnrollment();
        }
    };
</script>

